import { IconButton, Tooltip } from '@chakra-ui/react'
import { Delete } from 'src/components/icon'
import { useModal } from 'src/hooks/use-modal'
import { useSpinner } from 'src/hooks/use-spinner'
import { useMirohaToast } from 'src/lib/chakra-theme/components/toast/use-miroha-toast'
import { CancelExplanationReservationDocument } from 'src/lib/gql-client'
import { useGqlMutation } from 'src/lib/gql-client/request'
type Props = {
  explanationReservationUid: string
  mutateExplanation: () => void
}

export const CancelReservationButton: React.FC<Props> = ({
  explanationReservationUid,
  mutateExplanation,
}) => {
  const toast = useMirohaToast()

  const { showModal } = useModal()

  const { showSpinner, hideSpinner } = useSpinner()

  const { request: cancelReservation } = useGqlMutation(
    CancelExplanationReservationDocument,
    {
      onRequestStarted: showSpinner,
      onRequestDone: hideSpinner,
      onSuccess: () => {
        mutateExplanation()
        toast({
          status: 'success',
          title: '面談予約を取り消しました。',
        })
      },
    },
  )

  return (
    <Tooltip label="削除">
      <IconButton
        variant="customIconButtonGhost"
        icon={<Delete />}
        aria-label="面談予定削除"
        onClick={async () => {
          showModal({
            title: '面談予約を取り消しますか？',
            content: '取り消し時には案内先へ取消のメールが送信されます。',
            submitText: '取り消す',
            size: 'xl',
            submitButtonColor: 'red',
            onSubmit: async () => {
              await cancelReservation({
                input: {
                  explanationReservationUid,
                },
              })
            },
          })
          return
        }}
      />
    </Tooltip>
  )
}
